var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(_vm.$t('oauth.redirecting')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }